<template>
  <transition name="fade">
    <div v-if="profile">
      <!-- BUTTON -->
      <b-button
        v-if="isVelloPackEnabled"
        class="btn-primary py-1 pl-1 pr-2 radius-10 cursor"
        style="min-width: 165px"
        v-b-modal.addVellosForm
      >
        <small
          class="font-weight-bold d-inline-block float-left py-1 px-2 border radius-10 m-1"
          v-text="
            profile.question_credits
              ? profile.question_credits.total_available_credits
              : 0
          "
        />
        <p class="d-inline-block m-0 text-left">
          <span class="d-block">
            <strong>+ Add Vellos</strong>
          </span>
          <small class="d-block mt-n2">
            <small>Purchase per pack</small>
          </small>
        </p>
      </b-button>

      <b-button
        v-else
        disabled
        class="btn-black p-2 radius-10 v-center"
        style="min-width: 163px"
      >
        <small
          class="font-weight-bold d-inline-block float-left py-1 px-2 mr-2 border radius-10"
          v-text="
            profile.question_credits
              ? profile.question_credits.total_available_credits
              : 0
          "
        />
        <p class="d-inline-block m-0">
          <span class="d-block">
            <strong>Vellos Ready</strong>
          </span>
        </p>
      </b-button>

      <!-- MODAL FORM -->
      <add-vellos-modal />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import AddVellosModal from './AddVellosModal'

export default {
  name: 'AddVellosButton',
  components: {
    AddVellosModal,
  },
  computed: {
    ...mapState({
      profile: (state) => state.influencer.profile,
    }),

    isVelloPackEnabled() {
      return (
        this.profile.influencer.package_settings.is_augmented_pack_enabled ||
        (this.profile.influencer.package_settings.is_single_pack_enabled &&
          !this.profile.influencer.show_waitlist_to_purchase_pack)
      )
    },
  },
}
</script>

<style scoped></style>
